/**
 * Single source of truth for customer-facing brand tokens (FE-05a).
 * Keep public/index.html and public/manifest.json in sync with paths/colors here.
 * FE-05b (new visual brand) only changes this file once the name is decided.
 */

export const brand = {
  name: "SV City Trans",
  shortName: "SV City Trans",
  /** Default <title> / og:title */
  title: "SV City Trans",
  /** meta description / og:description */
  description: "Надійні міжнародні перевезення",
  /** Longer product line for og when needed */
  tagline: "Міжнародні автобусні квитки з України",

  colors: {
    primary: "#1E3A8A",
    primaryDark: "#152A6B",
    primaryLight: "#2D4BA8",
    /** Positive / feature accent (icons, checkmarks) */
    accent: "#7BC043",
  },

  /** Header / footer logo (white-on-brand) */
  logoSrc: "/images/HeaderLogo 1.png",
  /** PWA / apple touch / favicon — files under public/images/ */
  favicon: "/images/BlueBus1.ico",
  appleTouchIcon: "/images/BlueBus1.png",
  pwaIcon192: "/images/BlueBus1.png",
  pwaIcon512: "/images/BlueBus1.png",
  /** Open Graph / Twitter card image (1200×630) */
  ogImage: "/images/og-card.png",
  features: {
    card_payment: process.env.REACT_APP_PAYMENT_ENABLED === "true",
    partner_sales: process.env.REACT_APP_PARTNER_PROVIDER_SALES_ENABLED === "true",
  },
};

/** Alias used across the app for palette tokens (was theme.BRAND). */
export const BRAND = brand.colors;

/** Browser / PWA chrome color — same as primary. */
export const themeColor = brand.colors.primary;

export default brand;
